import {
    Align,
    FlexBox,
    GapSize,
    Image,
    List,
    ListItem,
    Text,
    TextLevels,
    TypographyAlign,
} from '@bytel/trilogy-react';

import { NuggetListItem } from '@app-types/nugget';

interface NuggetsListProps {
    nuggets: NuggetListItem[];
}

export function NuggetsList({ nuggets }: Readonly<NuggetsListProps>) {
    if (!nuggets.length) {
        return null;
    }

    return (
        <List>
            {nuggets.map((nugget) => (
                <ListItem key={nugget.key} iconName={nugget.image ? undefined : nugget.icon}>
                    <FlexBox align={Align.CENTER} gap={GapSize.TWO}>
                        {nugget.image && <Image src={nugget.image} className='icon' alt='' />}
                        <Text level={TextLevels.TWO} marginless typo={TypographyAlign.TEXT_LEFT}>
                            {nugget.content}
                        </Text>
                    </FlexBox>
                </ListItem>
            ))}
        </List>
    );
}
